window.addEventListener('pageshow', function(e) {
  if (e.persisted) {  // e.persisted = true 说明是从 BFCache 恢复的
    close();
    var binBtn = document.getElementById('qv-bin-btn');
    if (binBtn) {
      binBtn.disabled = false;
      binBtn.textContent = 'BUY IT NOW';
    }
  }
});
window.QV = (function () {
  var product = null;
  var selectedOptions = {};
  var quantity = 1;

  function getFullSrc(src) {
    if (!src) return '';
    // 处理协议相对 URL
    if (src.indexOf('//') === 0) src = 'https:' + src;
    // 移除 Shopify 图片尺寸后缀，例如 _480x640.jpg → .jpg
    src = src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|\d+x\d*|\d*x\d+)(@\dx)?(\.[a-zA-Z]+)(\?|$)/, '$3$4');
    return src;
  }

  // 修复 Shopify 图片 URL（确保是完整 https URL）
  function normalizeImageUrl(src) {
    if (!src) return '';
    // 已经是完整 URL
    if (src.startsWith('http://') || src.startsWith('https://')) return src;
    // 协议相对 URL
    if (src.startsWith('//')) return 'https:' + src;
    return src;
  }

  function open(handle) {
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        product = data;
        quantity = 1;
        selectedOptions = {};

        var firstVariant =
          product.variants.find(function (v) { return v.available; }) ||
          product.variants[0];

        product.options.forEach(function (opt, i) {
          selectedOptions[opt.name] = firstVariant['option' + (i + 1)];
        });

        render();
        var overlay = document.getElementById('qv-overlay');
        overlay.classList.add('is-open');
        overlay.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      })
      .catch(function (err) {
        console.error('[QuickView] Failed to load product:', err);
      });
  }

  function render() {
    document.getElementById('qv-title').textContent = product.title;
    document.getElementById('qv-qty').textContent = quantity;
    document.getElementById('qv-desc').innerHTML = product.description; // 确保这行存在且没有被注释
    renderImages();
    renderOptions();
    updateVariant();

    // 渲染完成后再重置滚动位置
    setTimeout(function() {
      var modal = document.querySelector('.qv-modal');
      if (modal) modal.scrollTop = 0;
    }, 50);
  }

  function renderImages() {
    var mainImg = document.getElementById('qv-main-img');
    var thumbsEl = document.getElementById('qv-thumbs');
    thumbsEl.innerHTML = '';

    // product.images 是字符串数组，直接用元素本身作为 URL
    var images = product.images || [];

    // fallback：如果 images 为空，用 featured_image（也是字符串）
    if (images.length === 0 && product.featured_image) {
      images = [product.featured_image];
    }

    if (images.length === 0) {
      mainImg.src = '';
      return;
    }

    function toSrc(item) {
      // 兼容字符串和对象两种格式
      var src = (typeof item === 'string') ? item : (item.src || item.url || '');
      if (src.indexOf('//') === 0) src = 'https:' + src;
      return src;
    }

    mainImg.src = toSrc(images[0]);
    mainImg.alt = product.title;

    images.forEach(function (img, idx) {
      var src = toSrc(img);
      var thumb = document.createElement('img');
      thumb.src = src;
      thumb.alt = product.title + ' ' + (idx + 1);
      if (idx === 0) thumb.classList.add('is-active');

      thumb.onerror = function () { thumb.style.display = 'none'; };

      thumb.addEventListener('click', function () {
        mainImg.src = src;
        thumbsEl.querySelectorAll('img').forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });

      thumbsEl.appendChild(thumb);
    });
  }


  function renderOptions() {
    var container = document.getElementById('qv-options');
    container.innerHTML = '';

    product.options.forEach(function (option) {
      var group = document.createElement('div');
      group.className = 'qv-option-group';

      var label = document.createElement('div');
      label.className = 'qv-option-label';
      label.textContent = option.name + ': ' + (selectedOptions[option.name] || '');
      label.setAttribute('data-option', option.name);
      group.appendChild(label);

      var values = document.createElement('div');
      values.className = 'qv-option-values';

      option.values.forEach(function (val) {
        var btn = document.createElement('button');
        btn.title = val;
        btn.className = 'qv-option-btn';
        btn.textContent = val;

        if (selectedOptions[option.name] === val) {
          btn.classList.add('is-active');
        }

        var hasAvailable = product.variants.some(function (v) {
          return v.options.indexOf(val) !== -1 && v.available;
        });
        if (!hasAvailable) btn.classList.add('is-disabled');

        btn.addEventListener('click', function () {
          if (btn.classList.contains('is-disabled')) return;
          selectedOptions[option.name] = val;
          label.textContent = option.name + ': ' + val;
          values.querySelectorAll('button').forEach(function (b) {
            b.classList.remove('is-active');
          });
          btn.classList.add('is-active');
          updateVariant();
        });

        values.appendChild(btn);
      });


      group.appendChild(values);
      container.appendChild(group);
    });
  }


  function updateVariant() {
    var matched = product.variants.find(function (v) {
      return product.options.every(function (opt, i) {
        return v['option' + (i + 1)] === selectedOptions[opt.name];
      });
    });

    var atcBtn = document.getElementById('qv-atc-btn');
    var priceEl = document.getElementById('qv-price');

    if (matched) {
      var price = (matched.price / 100).toFixed(2);
      var currency = window.Shopify && window.Shopify.currency
        ? window.Shopify.currency.active
        : 'USD';
      priceEl.textContent = '$' + price + ' ' + currency;

      atcBtn.disabled = !matched.available;
      atcBtn.textContent = matched.available ? 'ADD TO CART' : 'SOLD OUT';
      atcBtn.dataset.variantId = matched.id;

      var binBtn = document.getElementById('qv-bin-btn');
      if (binBtn) binBtn.dataset.variantId = matched.id;

      var detailLink = document.getElementById('qv-detail-link');
      if (detailLink) detailLink.href = '/products/' + product.handle;

      // 切换主图：优先用变体图片，没有就保持不变
      var mainImg = document.getElementById('qv-main-img');
      var thumbs = document.getElementById('qv-thumbs').querySelectorAll('img');

      if (matched.featured_image) {
        var variantSrc = matched.featured_image;
        if (typeof variantSrc === 'object') variantSrc = variantSrc.src || variantSrc.url || '';
        if (variantSrc.indexOf('//') === 0) variantSrc = 'https:' + variantSrc;

        if (variantSrc) {
          mainImg.src = variantSrc;

          // 同步高亮对应的缩略图
          thumbs.forEach(function (thumb) {
            thumb.classList.remove('is-active');
            // 比较缩略图 src 和变体图片 src（去掉尺寸参数后比较）
            var thumbSrc = thumb.src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|\d+x\d*|\d*x\d+)(@\dx)?(\.[a-zA-Z]+)/, '$3');
            var vSrc = variantSrc.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|\d+x\d*|\d*x\d+)(@\dx)?(\.[a-zA-Z]+)/, '$3');
            if (thumbSrc.split('?')[0] === vSrc.split('?')[0]) {
              thumb.classList.add('is-active');
            }
          });
        }
      }
    }
  }


  function changeQty(delta) {
    quantity = Math.max(1, quantity + delta);
    document.getElementById('qv-qty').textContent = quantity;
  }

  function addToCart() {
    var btn = document.getElementById('qv-atc-btn');
    var variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) return;

    btn.disabled = true;
    btn.textContent = 'ADDING...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        id: variantId, 
        quantity: quantity,
        sections: ['cart-counter', 'cart-drawer']  // 同时刷新数量和抽屉
      })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Cart add failed: ' + r.status);
      return r.json();
    })
    .then(function (data) {
      btn.textContent = '✓ ADDED';

      if (data.sections) {
        // 更新购物车数量角标
        if (data.sections['cart-counter']) {
          var parser = new DOMParser();
          var newDoc = parser.parseFromString(data.sections['cart-counter'], 'text/html');
          var newBadge = newDoc.querySelector('.cart-count-badge');
          var badge = document.querySelector('.cart-count-badge');
          if (badge && newBadge) {
            badge.textContent = newBadge.textContent;
            badge.classList.remove('hidden');
          }
        }

        // 更新购物车抽屉内容
        if (data.sections['cart-drawer']) {
          var parser2 = new DOMParser();
          var drawerDoc = parser2.parseFromString(data.sections['cart-drawer'], 'text/html');
          var newDrawerBody = drawerDoc.querySelector('#shopify-section-cart-drawer #CartDrawer-Body');
          var drawerBody = document.querySelector('#CartDrawer-Body');
          if (drawerBody && newDrawerBody) {
            drawerBody.innerHTML = newDrawerBody.innerHTML;
          }
        }
      }

      // setTimeout(function () { close(); }, 900);
      close()
      setTimeout(function() {
        var cartBtn = document.getElementById('cart-counter');
        if (cartBtn) cartBtn.click();
      }, 300);
    })
    .catch(function (err) {
      console.error('[QuickView] Add to cart error:', err);
      btn.disabled = false;
      btn.textContent = 'ADD TO CART';
    });
  }

  function buyItNow() {
    var variantId = document.getElementById('qv-atc-btn').dataset.variantId;
    if (!variantId) return;

    var btn = document.getElementById('qv-bin-btn');
    btn.disabled = true;
    btn.textContent = 'LOADING...';

    // 先清空购物车，再只添加这一件，然后跳转结账
    fetch('/cart/clear.js', { method: 'POST' })
      .then(function() {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity })
        });
      })
      .then(function() {
        var params = new URLSearchParams(window.location.search);
        var themeId = params.get('preview_theme_id');
        var checkoutUrl = '/checkout';
        if (themeId) checkoutUrl += '?preview_theme_id=' + themeId;
        window.location.href = checkoutUrl;
      })
      .catch(function(err) {
        console.error('Buy it now error:', err);
        btn.disabled = false;
        btn.textContent = 'BUY IT NOW';
      });
  }




  function close() {
    var overlay = document.getElementById('qv-overlay');
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function injectButtons() {
    document.querySelectorAll('card-product[data-handle]').forEach(function (card) {
      if (card.querySelector('.qv-trigger-btn')) return;

      var handle = card.getAttribute('data-handle');
      if (!handle) return;

      var mediaEl = card.querySelector('.card-product__media');
      if (!mediaEl) return;


      // 确保定位正确
      var pos = window.getComputedStyle(mediaEl).position;
      if (pos === 'static') mediaEl.style.position = 'relative';

      var btn = document.createElement('button');
      btn.className = 'qv-trigger-btn';
      // btn.textContent = 'Quick View';
      // 替换原来的 btn.textContent = 'Quick View';
      if (window.innerWidth <= 768) {
        // 购物袋图标
        // btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
        btn.innerHTML = `
          <svg width="24px" height="24px" viewBox="0 0 24 24" stroke="#111" color="#000000" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 8H20V17C20 18.6569 18.6569 20 17 20H7C5.34315 20 4 18.6569 4 17V8Z" stroke="currentColor" stroke-width="1.0" stroke-linejoin="square" data-ignore-fill=""></path>
        <path d="M8 8V7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7V8" stroke="currentColor" stroke-width="1.0" stroke-linejoin="square" data-ignore-fill=""></path>
      </svg>
        `
      } else {
        btn.textContent = 'Quick View';
      }

      btn.setAttribute('aria-label', 'Quick view');

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        open(handle);
      });

      // mediaEl.appendChild(btn);
      mediaEl.parentElement.style.position = 'relative';
      mediaEl.parentElement.appendChild(btn);
    });
  }

  function init() {
    // 关闭：点击背景
    document.getElementById('qv-overlay').addEventListener('click', function (e) {
      if (e.target === this) close();
    });
    // 关闭：ESC
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
    // 关闭按钮
    var closeBtn = document.getElementById('qv-close-btn');
    if (closeBtn) closeBtn.addEventListener('click', close);

    injectButtons();

    // 监听动态内容（无限滚动等）
    var observer = new MutationObserver(function () { injectButtons(); });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  return {
    open: open,
    close: close,
    changeQty: changeQty,
    addToCart: addToCart,
    buyItNow: buyItNow,  // 加上这行
    init: init
  };
})();

document.addEventListener('DOMContentLoaded', function () { QV.init(); });
